<script lang="ts">
  import type { ShotSource } from "./sources.ts";

  let {
    sources,
    alt,
    loading = "lazy",
    priority = "auto",
    class: className,
  }: {
    sources: readonly ShotSource[];
    alt: string;
    loading?: "lazy" | "eager";
    priority?: "high" | "low" | "auto";
    class: string;
  } = $props();

  const fallback = $derived(sources.at(-1));

  const avif = (source: ShotSource): string =>
    `${source.path}.1x.avif 1x, ${source.path}.2x.avif 2x`;

  const webp = (source: ShotSource): string => `${source.path}.1x.webp`;

  const webpSet = (source: ShotSource): string | undefined =>
    source.webp2x === true ? `${webp(source)} 1x, ${source.path}.2x.webp 2x` : undefined;

  const media = (source: ShotSource): string | undefined =>
    source.from === 0 ? undefined : `(min-width: ${source.from / 16}rem)`;
</script>

{#if fallback !== undefined}
  <picture>
    {#each sources as source (source.from)}
      <source
        type="image/avif"
        media={media(source)}
        srcset={avif(source)}
        width={source.width}
        height={source.height}
      />
      {#if source !== fallback}
        <source
          type="image/webp"
          media={media(source)}
          srcset={webpSet(source) ?? webp(source)}
          width={source.width}
          height={source.height}
        />
      {/if}
    {/each}
    <img
      src={webp(fallback)}
      srcset={webpSet(fallback)}
      width={fallback.width}
      height={fallback.height}
      {alt}
      {loading}
      fetchpriority={priority}
      decoding="async"
      class={className}
    />
  </picture>
{/if}
